import React from 'react';
import styled from 'styled-components';
import {Row} from 'react-table';
import {
  PreleadProject,
  useClientPreleadCustomizeItemsByProjectQuery,
} from 'api';
import {useParams} from 'react-router';

interface Props {
  row: Row<PreleadProject>;
  value: any;
}

const CustomizeItemSelectCell = ({row, value}: Props) => {
  const preleadProject: PreleadProject = row.original;
  const clientPreleadCustomizeItemId = value;

  const {projectId} = useParams<{
    projectId: string;
  }>();

  const {data: {clientPreleadCustomizeItemsByProject = []} = {}} =
    useClientPreleadCustomizeItemsByProjectQuery({
      variables: {uuid: projectId},
    });

  const customizeItem = React.useMemo(
    () =>
      preleadProject.prelead.customizeItemSelects.find(
        (item) =>
          item.clientPreleadCustomizeItemId === clientPreleadCustomizeItemId,
      ),
    [preleadProject, clientPreleadCustomizeItemId],
  );

  const clientPreleadCustomizeItem = React.useMemo(
    () =>
      clientPreleadCustomizeItemsByProject.find(
        (item) => item.id === clientPreleadCustomizeItemId,
      ),
    [clientPreleadCustomizeItemsByProject, clientPreleadCustomizeItemId],
  );

  const tags = React.useMemo(
    () =>
      customizeItem && clientPreleadCustomizeItem
        ? clientPreleadCustomizeItem.selectOptions.filter((option) =>
            customizeItem?.clientPreleadCustomizeItemSelectOptionIds.includes(
              option.id,
            ),
          )
        : [],
    [customizeItem, clientPreleadCustomizeItem],
  );

  return (
    <Container>
      {tags.map((tag) => (
        <Tag key={tag.id}>{tag.label}</Tag>
      ))}
    </Container>
  );
};

export default CustomizeItemSelectCell;

const Container = styled.div`
  display: flex;
  gap: 3px;
`;

const Tag = styled.span`
  padding: 1px 8px;
  background: #f5f5f5;
  border-radius: 2px;
  font-size: 9px;
  letter-spacing: 0.15px;
`;
